module.exports = __webpack_public_path__ + "static/media/6.75a35218.jpg";